module.exports = __webpack_public_path__ + "img/thumbnail_EuropeanPeacock_u_normal.d0e6ec83.png";